module.exports = __webpack_public_path__ + "img/mardelplata_fall.c0d050c4.svg";